import { Base } from '../base.model';

// Internal Chat models (SPEC-2026-07-internal-chat, T-16).
// Manual mirror of trendmulti-apps/libs/trendmulti-entity/src/entity/chat/
// chat-channel.entity.ts — the web NEVER imports from trendmulti-apps
// (rcs-message mirror precedent). Enum values MUST stay byte-identical to the
// backend contract.

export enum ChatChannelTypeEnum {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  DIRECT = 'DIRECT',
  GROUP = 'GROUP',
}

// chatdb refs (User/Company/ChatMessage) are never populated cross-database —
// they always travel as ObjectId strings over REST and socket payloads.
export interface ChatChannel extends Base {
  /** optional — DIRECT/GROUP conversations are unnamed */
  name?: string;
  description?: string;
  type: ChatChannelTypeEnum;
  /** Company id (appdb) — string only, never populated */
  company: string;
  /** User id (appdb) — string only, never populated */
  createdBy: string;
  archived: boolean;
  archivedBy?: string;
  archivedAt?: Date;
  /** sorted "userIdA:userIdB" — DIRECT only; self pair allowed (personal notes) */
  directKey?: string;
  /** denormalized on send — conversation list previews and activity sort */
  lastMessageAt?: Date;
  lastMessagePreview?: string;
  pinnedMessages: Array<PinnedChatMessage>;
}

export interface PinnedChatMessage {
  /** ChatMessage id */
  message: string;
  /** User id */
  pinnedBy: string;
  pinnedAt: Date;
}
